export const HOME_PAGE_TEMPLATE = 'home';
export const ABOUT_PAGE_TEMPLATE = 'about';
export const FAQ_PAGE_TEMPLATE = 'faq';
export const HEPBNOW_PAGE_TEMPLATE = 'design';
export const EVENT_TEMPLATE = 'event';

export const AVAILABLE_TEMPLATES = {
  design: 'design',
  event: 'event',
};
const FONT_WEIGHTS = {
  regular: 'normal',
  medium: '500',
  semiBold: '600',
  bold: 'bold',
};

export const SUPPORTING_FONT_TYPES = {
  header1: {
    styleVariable: '--design-page-header1-font',
    fontSizeVariable: '--design-page-header1-font-size',
    className: 'design-page-header1',
    styles: {
      fontWeight: FONT_WEIGHTS.bold,
      lineHeight: '1.3',
    },
  },
  header2: {
    styleVariable: '--design-page-header2-font',
    fontSizeVariable: '--design-page-header2-font-size',
    className: 'design-page-header2',
    styles: {
      fontWeight: FONT_WEIGHTS.bold,
      lineHeight: '1.3',
    },
  },
  subHeader: {
    styleVariable: '--design-page-sub-header-font',
    fontSizeVariable: '--design-page-sub-header-font-size',
    className: 'design-page-sub-header',
    styles: {
      fontWeight: FONT_WEIGHTS.medium,
      lineHeight: '1.3',
    },
  },
  subHeader2: {
    styleVariable: '--design-page-sub-header2-font',
    fontSizeVariable: '--design-page-sub-header2-font-size',
    className: 'design-page-sub-header2',
    styles: {
      fontWeight: FONT_WEIGHTS.bold,
      lineHeight: '1.3',
    },
  },
  body: {
    styleVariable: '--design-page-body-font',
    fontSizeVariable: '--design-page-body-font-size',
    className: 'design-page-body',
    styles: {
      lineHeight: '1.5',
    },
  },
  button: {
    styleVariable: '--design-page-button-font',
    fontSizeVariable: '--design-page-button-font-size',
    className: 'design-page-button',
    styles: {
      fontWeight: FONT_WEIGHTS.semiBold,
    },
  },
  caption: {
    styleVariable: '--design-page-caption-font',
    fontSizeVariable: '--design-page-caption-font-size',
    className: 'design-page-caption',
  },
  tag: {
    styleVariable: '--design-page-tag-font',
    fontSizeVariable: '--design-page-tag-font-size',
    className: 'design-page-tag',
    styles: {
      fontWeight: FONT_WEIGHTS.regular,
      lineHeight: '1.3',
    },
  },
};

// Which font type a block-level color attribute implies. `background` has no font
// meaning. `title` maps to header2: elements colored by --design-page-title-color
// consistently size themselves with --design-page-header2-font-size.
// Human labels, mirroring the admin app's SUPPORTING_FONT_TYPES labels.
export const FONT_TYPE_LABELS = {
  header1: 'Header 1',
  header2: 'Header 2',
  subHeader: 'Sub-header 1',
  subHeader2: 'Sub-header 2',
  body: 'Body',
  button: 'Button',
  caption: 'Caption',
  tag: 'Tag',
};

export const FONT_TYPE_HELPER_TEXTS = {
  header1: 'Edit the page header (header 1)',
  header2: 'Edit the section header (header 2)',
  subHeader1: 'Edit the sub-header 1',
  subHeader2: 'Edit the sub-header 2',
  body: 'Edit the regular body text',
  bodyTitle: 'Edit paragraph title - body style',
  bodyBold: 'Edit the bold body text',
  button: 'Edit the button content',
  caption: 'Edit the image caption',
};
